import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    msg: '',//要存的东西
    role: '',//角色
  }
})

export default store;



// WEBPACK FOOTER //
// ./src/store.js